import { runInAction, makeAutoObservable } from "mobx";
import { randmarApiWithTags } from "randmar-api-client";
import { store } from "../../new-store/store";
import Return from "./Return";

/**
 * @deprecated This store is deprecated and will be removed in a future version.
 * Please use RTK Query hooks for fetching returns data.
 * For manufacturer returns, use `useGetV4ManufacturerByRouteManufacturerIdReturnsQuery`.
 * For reseller returns, use `useGetV4ResellerByRouteResellerIdReturnsQuery`.
 */
class ReturnsStore {
  returns: Return[] = [];
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
    console.warn(
      "Deprecation Warning: The legacy 'ReturnsStore' is in use. Please migrate to RTK Query as outlined in CONTRIBUTING.md."
    );
  }

  getReturns = async (applicationId: string) => {
    this.isLoading = true;
    try {
      const info = await store.dispatch(
        randmarApiWithTags.endpoints.getV4ManufacturerByRouteManufacturerIdReturns.initiate({
          routeManufacturerId: applicationId,
        })
      ).unwrap();
      const returns = info.map(Return.convertFrom);

      runInAction(() => {
        this.returns = returns;
      });
    } catch (e) {
      console.error(e);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }
}

export default ReturnsStore;
